import { render } from "./BeefCattleDataForm.vue?vue&type=template&id=208120be&scoped=true&ts=true"
import script from "./BeefCattleDataForm.vue?vue&type=script&lang=ts"
export * from "./BeefCattleDataForm.vue?vue&type=script&lang=ts"

import "./BeefCattleDataForm.vue?vue&type=style&index=0&id=208120be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208120be"]])

export default __exports__